import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merges multiple class names into a single string, resolving Tailwind CSS conflicts.
 * This utility is used by shadcn components for handling dynamic class name generation.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

